/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { AppContext } from "components/AppContext";
import * as _ from "underscore";
import moment from "moment";
import statusPrettier from "shared/statusprettier";
import formatTime from "./Components/FormatTime";
import ModalActionsKebab from "./Components/ModalActionsKebab";
// eslint-disable-next-line import/no-cycle
import DetailsModal from "./Components/DetailsModal";
import "moment-timezone";
import { constrctFilterToken } from "./Components/ReportTable";
import { useHistory, useParams } from "react-router-dom";

const parser = require("cron-parser");

const ExtractReportContext = React.createContext();
const { Provider, Consumer } = ExtractReportContext;

const ExtractReportProvider = props => {
  const { children } = props;
  const { StoreAPIDefaults, timezone, config, signOut } = useContext(
    AppContext
  );
  const { id: accountId } = useParams();

  const [error, setError] = useState(false);
  const [UIAlert, setUIAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState(false);
  const [reportsQueried, setReportsQueried] = useState(false);
  const [reportSearchTerm, setReportSearchTerm] = useState();
  const [slideData, setSlideData] = useState();
  const [runReportStatus, setRunReportStatus] = useState();
  const [paginationToken, setPaginationToken] = useState(null);
  const [newToken, setNewToken] = useState("");
  const [filterConfig, setFilterConfig] = useState(null);
  const [currentPaginationProps, setCurrentPaginationProps] = useState(null);
  const [clearFilters, setClearFilters] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [modalState, setModalState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false
  });
  const [filters, setFilters] = useState({
    lastRunStatus: null,
    lastRunTime: null,
    scheduleStatus: null,
    createdBy: null
  });
  const [selectedFilters, setSelectedFilters] = useState({
    lastRunStatus: null,
    lastRunTime: null,
    scheduleStatus: null,
    createdBy: null
  });
  const [filterTypeCount, setFilterTypeCount] = useState({
    lastRunStatus: 0,
    lastRunTime: 0,
    scheduleStatus: 0,
    createdBy: 0
  });
  const [deleteModalState, setDeleteModalState] = useState(false);
  const history = useHistory();

  const formatDuration = (start, finish) => {
    const startformat = moment(start).format("YYYY/MM/DD HH:mm");
    const finishformat = moment(finish).format("YYYY/MM/DD HH:mm");
    let durationTime = moment
      .duration(
        moment(finishformat, "YYYY/MM/DD HH:mm").diff(
          moment(startformat, "YYYY/MM/DD HH:mm")
        )
      )
      .asMinutes();

    if (durationTime === 0) {
      durationTime = "< 1 min";
    }
    return `${Math.round(durationTime)} mins`;
  };
  const getReports = ({ filters, isFiltersClear }) => {
    if (
      StoreAPIDefaults.accessToken &&
      (newToken !== null || isFiltersClear || isDeleted)
    ) {
      setLoading("Getting Extracts");
      axios
        .get(`${config.configApiBaseUrl}/accounts/${accountId}/reports`, {
          headers: {
            Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
          },
          params: {
            paginationtoken: paginationToken,
            ...(filters && {
              filters
            })
          }
        })
        .then(response => {
          setLoading(false);
          setNewToken(response.data.paginationtoken);
          setIsDeleted(false);
          if (reports) {
            setReports([...reports, ...response.data.data]);
          } else {
            setReports(response.data.data);
          }
          if (currentPaginationProps) {
            setTimeout(() => {
              currentPaginationProps.gotoPage(currentPaginationProps.pageIndex);
            }, 0);
          }
        })
        .catch(err => {
          console.log(err);
          if (err?.response?.status === 401) {
            signOut();
          } else {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: err
              }
            });
          }
          setLoading(false);
          setError(err);
        });
    }
  };

  const clearSearch = () => {
    // focus issue with sliding pane fixed by next line
    setSlideData();

    setReportsQueried(false);
    setReportSearchTerm("");
  };

  const runReport = (account, dag, report) => {
    setRunReportStatus("");
    if (StoreAPIDefaults.accessToken) {
      setRunReportStatus("loading");
      axios
        .post(
          `${config.configApiBaseUrl}/accounts/${account}/dags/${dag}/reports/${report}/execute`,
          {},
          {
            headers: {
              Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
            }
          }
        )
        .then(() => {
          setRunReportStatus("success");
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
          if (err?.response?.status === 401) {
            signOut();
          } else {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: err
              }
            });
          }
          setRunReportStatus("error");
          setLoading(false);
        });
    }
  };

  const runReportKebab = (account, dag, report) => {
    if (StoreAPIDefaults.accessToken) {
      setLoading("Requesting Extract Run");
      runReport(account, dag, report);
    }
  };

  const downloadReport = (account, dag, report, execution) => {
    setLoading("Downloading Run");

    if (StoreAPIDefaults.accessToken) {
      const executions = execution ? `/executions/${execution}` : "";

      axios
        .get(
          `${config.configApiBaseUrl}/accounts/${account}/dags/${dag}/reports/${report}${executions}/download?redirect=0`,
          {
            headers: {
              Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
            }
          }
        )
        .then(response => {
          setLoading(false);
          window.location = response.data.data.Location;
        })
        .catch(err => {
          if (err?.response?.status === 401) {
            signOut();
          } else {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: err
              }
            });
          }
          setLoading(false);
          setUIAlert("Extract failed to download. Please try again later.");
        });
    }
  };

  const getReportHistory = (account, dag, report) => {
    setLoading("Getting Run History");
    if (StoreAPIDefaults.accessToken) {
      let reportobj = _.filter(reports, r => {
        if (r.reportid == report) {
          return r;
        }
      });

      axios
        .get(
          `${config.configApiBaseUrl}/accounts/${account}/dags/${dag}/reports/${report}/executions`,
          {
            headers: {
              Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
            }
          }
        )
        .then(response => {
          const formatedData = [];
          response.data.data.forEach(execution => {
            const starttime = formatTime(execution.createdon, timezone);
            const endtime = formatTime(execution.updatedon, timezone);

            let durationCalc;
            if (
              execution.executionduration &&
              (execution.querystatus === "SUCCESS" ||
                execution.querystatus === "ERROR")
            ) {
              const formatHolder = moment
                .duration(execution.executionduration * 1000)
                .asMinutes();

              if (formatHolder === 0 || formatHolder < 1) {
                durationCalc = "< 1 min";
              } else {
                durationCalc = `${Math.round(formatHolder)} mins`;
              }
            } else if (
              execution.createdon &&
              execution.updatedon &&
              execution.querystatus === "SUCCESS"
            ) {
              durationCalc = formatDuration(
                execution.createdon,
                execution.updatedon
              );
            } else {
              durationCalc = "---";
            }

            formatedData.push({
              runStatus: `${statusPrettier(execution.querystatus)}`,
              startTime: starttime,
              endTime:
                execution.querystatus === "INPROGRESS" ||
                execution.querystatus === "QUEUED"
                  ? "---"
                  : endtime,
              duration: durationCalc,
              actions: (
                <ModalActionsKebab
                  disabled={
                    execution.querystatus === "INPROGRESS" ||
                    execution.querystatus === "QUEUED"
                  }
                  failed={execution.querystatus === "ERROR"}
                  complete={execution.querystatus === "SUCCESS"}
                  account={reportobj[0].accountid}
                  dag={reportobj[0].dagid}
                  report={reportobj[0].reportid}
                  execution={execution.reportexecutionid}
                  downloadAction={downloadReport}
                />
              )
            });
          });

          if (response.data.data.length === formatedData.length) {
            setSlideData({
              content: (
                <DetailsModal
                  hideHeader
                  title={reportobj[0].reporttitle}
                  subtitle={reportobj[0].reportdescription}
                  createdBy={reportobj[0].createdby}
                  modifiedBy={reportobj[0].updatedby}
                  button={
                    (reportobj[0].reportlaststatus === "ERROR" ||
                      reportobj[0].reportlaststatus === "SUCCESS" ||
                      reportobj[0].reportlaststatus === "NA" ||
                      reportobj[0].reportlaststatus === null) &&
                    (() => runReport(account, dag, report))
                  }
                  content={formatedData}
                  reportlaststatus={reportobj[0].reportlaststatus}
                  runReportStatus={runReportStatus}
                  reportData={reportobj[0]}
                />
              )
            });
            setLoading(false);
          }
        })
        .catch(err => {
          console.log(err);
          if (err?.response?.status === 401) {
            signOut();
          } else {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: err
              }
            });
          }
          setError(err.response.status);
        });
    }
  };

  const resetReportsGrid = () => {
    setReports(null);
    setNewToken("");
    setPaginationToken(null);
  };
  const DeleteReport = deleteReportData => {
    setLoading("Deleting Report");

    if (StoreAPIDefaults.accessToken) {
      axios
        .delete(
          `${config.configApiBaseUrl}/accounts/${deleteReportData.accountid}/dags/${deleteReportData.dagid}/reports/${deleteReportData.reportid}`,
          {
            headers: {
              Authorization: `Bearer ${StoreAPIDefaults.accessToken}`
            }
          }
        )
        .then(response => {
          resetReportsGrid();
          setLoading(false);
          setIsDeleted(true);
          setDeleteModalState(false);
        })
        .catch(err => {
          if (err?.response?.status === 401) {
            signOut();
          } else {
            history.push({
              pathname: "/app/errordisplay",
              state: {
                error: err
              }
            });
          }
          setLoading(false);
          setUIAlert("Extract failed to delete. Please try again later.");
        });
    }
  };

  const refetchReports = () => {
    const persistedFilters = window.localStorage.getItem("REPORT_FILTERS");
    const parsedFilters = JSON.parse(persistedFilters);
    if (parsedFilters) {
      const filtertoken = constrctFilterToken({
        selectedOption: parsedFilters?.lastRunStatus,
        selectedScheduleOptions: parsedFilters?.scheduleStatus,
        searchTerm: parsedFilters?.searchTerm,
        startDate: parsedFilters?.startDate,
        endDate: parsedFilters?.endDate
      });
      getReports({ filters: filtertoken, isFiltersClear: false });
    } else if (clearFilters) {
      getReports({ filters: null, isFiltersClear: true });
    } else {
      getReports({ filters: filterConfig, isFiltersClear: false });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setRunReportStatus("");
    }, 9000);
  }, [runReportStatus, modalState.isPaneOpen]);

  useEffect(() => {
    refetchReports();
  }, [paginationToken, filterConfig, clearFilters, isDeleted]);

  return (
    <Provider
      value={{
        loading,
        error,
        UIAlert,
        setUIAlert,
        reports,
        reportsQueried,
        setReportsQueried,
        reportSearchTerm,
        setReportSearchTerm,
        filters,
        selectedFilters,
        setSelectedFilters,
        filterTypeCount,
        setFilterTypeCount,
        getReportHistory,
        slideData,
        runReportKebab,
        runReportStatus,
        setRunReportStatus,
        modalState,
        setModalState,
        downloadReport,
        clearSearch,
        setPaginationToken,
        filterConfig,
        setFilterConfig,
        resetReportsGrid,
        setSlideData,
        newToken,
        currentPaginationProps,
        setCurrentPaginationProps,
        setClearFilters,
        deleteModalState,
        setDeleteModalState,
        DeleteReport
      }}
    >
      {children}
    </Provider>
  );
};

ExtractReportProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export {
  ExtractReportProvider,
  Consumer as ExtractReportConsumer,
  ExtractReportContext
};
